/** Scrolls `list` sideways just enough to show `tab`; never scrolls any other container. */
export function revealTab(list: HTMLElement | null, tab: HTMLElement | null): void {
    if (!list || !tab) return;
    const listBox = list.getBoundingClientRect();
    const tabBox = tab.getBoundingClientRect();
    if (tabBox.left < listBox.left) list.scrollLeft -= listBox.left - tabBox.left;
    else if (tabBox.right > listBox.right) list.scrollLeft += tabBox.right - listBox.right;
}
